import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useTransactions } from '@/api';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { TransactionsPanel } from '@/ui/profile';

export const Route = createFileRoute('/profile/transactions')({
  component: ProfileTransactionsPage,
});

function ProfileTransactionsPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const transactions = useTransactions(true);

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('Transactions', 'Transactions')}
        </h1>
        <p className="text-[13px] text-text-secondary lg:text-[13px]">
          {label('Your betting and casino activity', 'Your betting and casino activity')}
        </p>
      </header>
      <TransactionsPanel transactions={transactions} />
    </div>
  );
}
